import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Lock, ShieldCheck, CreditCard, Zap } from 'lucide-react';
interface OfferSelectorProps {
  variant?: 'hero' | 'pricing' | 'final';
}
export function OfferSelector({
  variant = 'pricing'
}: OfferSelectorProps) {
  const [selectedOffer, setSelectedOffer] = useState<'19990' | '27990'>('27990');
  const checkoutUrls = {
    '19990': 'https://pagos.recursosfitness.shop/cart/44098718531681:1',
    '27990': 'https://pagos.recursosfitness.shop/cart/44098724757601:1'
  };
  const isDark = variant === 'hero' || variant === 'pricing';
  return <div className="w-full max-w-2xl mx-auto" data-id="element-205">
      <div className="space-y-3 mb-6" data-id="element-206">
        {/* Option 1: YOGA RESUELTA */}
        <motion.button onClick={() => setSelectedOffer('19990')} className={`w-full text-left p-4 rounded-xl border-2 transition-all ${selectedOffer === '19990' ? isDark ? 'border-yoga-gold bg-white/5' : 'border-yoga-purple-600 bg-yoga-purple-50' : isDark ? 'border-white/20 bg-white/5 hover:border-white/40' : 'border-gray-200 bg-white hover:border-gray-300'}`} whileHover={{
        scale: 1.01
      }} whileTap={{
        scale: 0.99
      }} data-id="element-207">
          <div className="flex items-center gap-4" data-id="element-208">
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedOffer === '19990' ? isDark ? 'border-yoga-gold bg-yoga-gold' : 'border-yoga-purple-600 bg-yoga-purple-600' : isDark ? 'border-white/40' : 'border-gray-300'}`} data-id="element-209">
              {selectedOffer === '19990' && <div className={`w-2 h-2 rounded-full ${isDark ? 'bg-yoga-purple-900' : 'bg-white'}`} data-id="element-210" />}
            </div>
            <div className="flex-1" data-id="element-211">
              <div className={`flex items-center gap-2 mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-212">
                <span className="text-lg" data-id="element-213">📘</span>
                <span className="font-bold text-sm md:text-base" data-id="element-214">
                  YOGA RESUELTA
                </span>
              </div>
              <div className={`text-xs md:text-sm ${isDark ? 'text-white/70' : 'text-gray-600'}`} data-id="element-215">
                6 tomos + 6 bonos
              </div>
            </div>
            <div className="text-right" data-id="element-216">
              <div className={`text-xs line-through ${isDark ? 'text-white/50' : 'text-gray-400'}`} data-id="element-217">
                $34.990
              </div>
              <div className={`text-2xl md:text-3xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-218">
                $19.990
              </div>
            </div>
          </div>
        </motion.button>

        {/* Option 2: PACK COMPLETO */}
        <motion.button onClick={() => setSelectedOffer('27990')} className={`w-full text-left p-4 rounded-xl border-2 transition-all relative ${selectedOffer === '27990' ? 'border-yoga-gold bg-gradient-to-r from-yoga-gold/10 to-yoga-gold/5' : isDark ? 'border-white/20 bg-white/5 hover:border-white/40' : 'border-gray-200 bg-white hover:border-gray-300'}`} whileHover={{
        scale: 1.01
      }} whileTap={{
        scale: 0.99
      }} data-id="element-219">
          <div className="flex items-center gap-2 mb-2" data-id="element-220">
            <span className="bg-yoga-gold text-yoga-purple-950 text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-221">
              MÁS ELEGIDO
            </span>
            <span className="bg-yoga-purple-900 text-yoga-gold text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-222">
              AHORRÁS $16.000
            </span>
          </div>
          <div className="flex items-center gap-4" data-id="element-223">
            <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedOffer === '27990' ? 'border-yoga-gold bg-yoga-gold' : isDark ? 'border-white/40' : 'border-gray-300'}`} data-id="element-224">
              {selectedOffer === '27990' && <div className="w-2 h-2 rounded-full bg-yoga-purple-900" data-id="element-225" />}
            </div>
            <div className="flex-1" data-id="element-226">
              <div className={`flex items-center gap-2 mb-1 ${isDark ? 'text-white' : 'text-gray-900'}`} data-id="element-227">
                <span className="text-lg" data-id="element-228">🏆</span>
                <span className="font-bold text-sm md:text-base" data-id="element-229">
                  PACK COMPLETO
                </span>
              </div>
              <div className={`text-xs md:text-sm ${isDark ? 'text-white/70' : 'text-gray-600'}`} data-id="element-230">
                6 tomos + 6 bonos + Yoga Terapéutico Pro™
              </div>
            </div>
            <div className="text-right" data-id="element-231">
              <div className={`text-xs line-through ${isDark ? 'text-white/50' : 'text-gray-400'}`} data-id="element-232">
                $43.990
              </div>
              <div className="text-2xl md:text-3xl font-bold text-yoga-gold" data-id="element-233">
                $27.990
              </div>
            </div>
          </div>
        </motion.button>
      </div>

      {/* CTA Button */}
      <motion.a href={checkoutUrls[selectedOffer]} whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className="block w-full bg-gradient-to-r from-yoga-gold-500 to-yoga-gold-600 hover:from-yoga-gold-400 hover:to-yoga-gold-500 text-yoga-purple-950 font-bold text-sm md:text-lg py-3 md:py-4 px-6 rounded-xl shadow-[0_0_30px_rgba(212,175,55,0.4)] transition-all text-center mb-3" data-id="element-234">
        <span className="flex items-center justify-center gap-2" data-id="element-235">
          <span className="text-lg md:text-xl" data-id="element-236">💥</span>
          SÍ, QUIERO MI YOGA RESUELTA AHORA →
        </span>
      </motion.a>

      <p className={`text-center text-xs md:text-sm italic mb-4 ${isDark ? 'text-white/60' : 'text-gray-500'}`} data-id="element-237">
        La opción más elegida por docentes que enseñan en los dos niveles
      </p>

      {/* Trust Badges */}
      <div className={`flex flex-wrap items-center justify-center gap-3 md:gap-4 text-xs md:text-sm ${isDark ? 'text-white/70' : 'text-gray-600'}`} data-id="element-238">
        <span className="flex items-center gap-1.5" data-id="element-239">
          <Lock size={14} className="text-yoga-gold" data-id="element-240" /> Pago seguro
        </span>
        <span className="flex items-center gap-1.5" data-id="element-241">
          <Zap size={14} className="text-yoga-gold" data-id="element-242" /> Acceso en 5 min
        </span>
        <span className="flex items-center gap-1.5" data-id="element-243">
          <ShieldCheck size={14} className="text-yoga-gold" data-id="element-244" /> Garantía 7 días
        </span>
        <span className="flex items-center gap-1.5" data-id="element-245">
          <CreditCard size={14} className="text-yoga-gold" data-id="element-246" /> Mercado Pago
        </span>
      </div>
    </div>;
}